import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultConnections,
  defaultConstruction,
  defaultContactInfo,
  defaultDescription,
  useManualAndInternationalAddress,
  usePurchasePriceOnRequestCondition,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const propertyOwnerStoreSellSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    mainFloorSpace: validationRules.mainFloorSpaceRequired,
    separableSpace: validationRules.separableSpace,
    totalFloorSpace: validationRules.totalFloorSpaceOptional,
    price: usePurchasePriceOnRequestCondition,
  },
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  otherFacilities: {
    frontWindowLength: validationRules.frontWindowLength,
    floorLoad: validationRules.floorLoad,
    totalFloorsNumber: validationRules.totalFloors,
    goodsLiftLoad: validationRules.loadLiftingValue,
    parkingSpaceRent: validationRules.parkingSpaceRent,
    noParkingSpaces: validationRules.noParkingSpaces,
  },
  connections: defaultConnections,
  contactInfo: defaultContactInfo,
  construction: defaultConstruction,
}
